import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { clearLoginMethod } from '@/lib/auth/firebase-oauth-session';
import { resetUserProfileHydration } from '@/providers/auth/user-profile-hydration-state';

import type { IUserProfile } from '@/typings/user';

interface IUserInfoState {
    userInfo: IUserProfile;
    isLogin: boolean;
    // 用户偏好设置
    preferences?: {
        theme: string;
        notifications: boolean;
    };
}

interface IUserInfoActions {
    setUserInfo: (userInfo: IUserProfile) => void;
    setIsLogin: (isLogin: boolean) => void;
    logout: () => void;
    updateUserInfo: (userInfo: Partial<IUserProfile>) => void;
    setPreferences: (preferences: Partial<IUserInfoState['preferences']>) => void;
}

const initialState: IUserInfoState = {
    userInfo: {
        avatar: '',
        balance: 0,
        create_time: '',
        email: '',
        login_source: 0,
        name: '',
        status: 0,
        user_id: '',
        roles: [],
        level: -1,
        auto_unlock_status: false,
    },
    // 是否登录
    isLogin: false,
    preferences: {
        theme: 'default',
        notifications: true,
    },
};

export const useUserInfoStore = create<IUserInfoState & IUserInfoActions>()(
    immer(set => ({
        ...initialState,
        setUserInfo: userInfo => set({ userInfo }),
        setIsLogin: isLogin => set({ isLogin }),
        logout: () => {
            // 仅退出时删除
            clearLoginMethod();
            resetUserProfileHydration();
            set({
                userInfo: {
                    avatar: '',
                    balance: 0,
                    create_time: '',
                    email: '',
                    login_source: 0,
                    name: '',
                    status: 0,
                    user_id: '',
                    roles: [],
                    level: -1,
                    auto_unlock_status: false,
                },
                isLogin: false,
            });
        },
        updateUserInfo: userInfo =>
            set(state => {
                Object.assign(state.userInfo, userInfo);
            }),
        setPreferences: preferences =>
            set(state => {
                if (!state.preferences) {
                    // 保证偏好字段始终存在
                    state.preferences = {
                        theme: 'light',
                        notifications: true,
                    };
                }
                Object.assign(state.preferences, preferences);
            }),
    }))
);
